<template>
  <div class="constructor" @keydown.esc="close">
    <m-items
      :active="isShowModalCreateGroup"
      :modal-title="createGroupModalTitle"
      input-placeholder="Введите название группы"
      :required-message="requiredMessage"
      :current-group-item="currentGroup"
      :input-max-length="64"
      @changeRequiredMessage="changeRequiredMessage"
      @close="closeModalCreateGroup"
      @createItem="createGroupRequest"
      @editItem="renameGroupRequest"
    />

    <m-items
      :create-category="true"
      :active="isShowModalCreateCategory"
      :groups="groupsForCreateCategoryModal"
      :current-group-select="currentSelectChosenGroupCode"
      :required-message="requiredMessage"
      :current-category-item="currentCategory"
      :modal-title="createCategoryModalTitle"
      :input-max-length="255"
      input-placeholder="Введите название категории"
      @changeRequiredMessage="changeRequiredMessage"
      @close="closeModalCreateCategory"
      @createItem="createCategoryRequest"
      @editItem="editCategoryRequest"
    />

    <m-items
      :modal-confirm="true"
      :active="isShowModalRemove"
      :modal-title="removeModalTitle"
      :modal-description="removeModalDescription"
      :modal-description-item="removeModalDescriptionItem"
      :remove-item="removeModalItem"
      :remove-item-type="removeModalItemType"
      @removeItemRequest="removeItemRequest"
      @close="closeModalRemove"
    />

    <c-sidesheet :active="localActive" @close="close">
      <div class="constructor__header">
        <svg
          class="constructor__header__close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="close"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="constructor__header__title">Настройка групп и категорий</div>
        <c-button-dropdown
          class="constructor__header__button"
          icon="arrow"
          :dropdown-with-icon="true"
          dropdown-icon="plus"
          dropdown-icon-color="blue"
          type="dropdown"
          label="Добавить"
          :dropdown="{
            position: 'left',
            items: [
              { label: 'Группу', emit: 'createGroup' },
              { label: 'Категорию', emit: 'createCategory' },
            ],
          }"
          @createGroup="openModalCreateGroup"
          @createCategory="openModalCreateCategory"
        />
      </div>
      <div class="constructor__wrapper">
        <div class="constructor__content">
          <div class="constructor__search">
            <c-input-old
              v-model="searchInput"
              icon="search"
              placeholder-style="italic"
              placeholder="Поиск"
              :clearable="true"
            />
          </div>

          <div class="constructor__sections">
            <div class="constructor__section">
              <div class="constructor__section-content">
                <draggable
                  :list="localItems"
                  group="groups"
                  :force-fallback="true"
                  ghost-class="sortable__ghost"
                  @change="moveGroupRequest($event, localItems)"
                >
                  <div v-for="(group, index) in localItems" :key="group.code">
                    <div
                      :id="`group-collapse-button-${group.groupId}`"
                      v-b-toggle="`group-collapse-${group.groupId}`"
                      :class="{ constructor__element__last: index + 1 === localItems.length }"
                      class="constructor__element constructor__element__bold"
                    >
                      <div class="constructor__element__ellipsis">
                        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z"
                            fill="#0066FF"
                          />
                          <path
                            d="M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z"
                            fill="#0066FF"
                          />
                        </svg>
                      </div>

                      <div class="constructor__element__name">{{ group.name }}</div>

                      <b-link class="constructor__element-icons" disabled>
                        <c-button
                          v-if="group.editable === 1"
                          v-b-popover.html="{
                            id: 'positions-button-popover',
                            container: '#app',
                            trigger: 'hover',
                            content: 'Редактировать',
                            placement: 'top',
                          }"
                          class="constructor__element-icons-edit"
                          size="iconic"
                          icon="edit"
                          @click="renameGroup(group)"
                        />
                        <c-button
                          v-if="hasCategoryWithPosts(group)"
                          v-b-popover.html="{
                            id: 'positions-disable-delete-popover',
                            container: '#app',
                            trigger: 'click blur',
                            content: getGroupTemplatePopover,
                          }"
                          v-b-tooltip.html="{
                            id: 'positions-button-tooltip',
                            container: '#app',
                            trigger: 'hover',
                            content: 'Удалить',
                            title: 'Удалить',
                            placement: 'top',
                          }"
                          container="disablePopoverPositions"
                          class="constructor__element-icons-delete"
                          :class="{
                            'constructor__element-icons-delete-disabled':
                              group.categories.length > 1 ||
                              (group.categories[0] !== undefined && group.categories[0].posts.length > 0),
                          }"
                          size="iconic"
                          :icon="{ icon: 'trash', color: 'secondary' }"
                          tooltip-with-icon="notice"
                        />
                        <c-button
                          v-if="shouldDisplayDeleteButton(group)"
                          v-b-popover.html="{
                            id: 'positions-button-popover',
                            container: '#app',
                            trigger: 'hover',
                            content: 'Удалить',
                            placement: 'top',
                          }"
                          class="constructor__element-icons-delete"
                          size="iconic"
                          :icon="{ icon: 'trash', color: 'secondary' }"
                          @click="openModalRemove(group, 'group')"
                        />
                        <c-button
                          v-b-popover.html="{
                            id: 'positions-button-popover',
                            container: '#app',
                            trigger: 'hover',
                            content: 'Переместить',
                            placement: 'top',
                          }"
                          size="iconic"
                          icon="arrows-constructor"
                        />
                      </b-link>
                    </div>

                    <b-collapse :id="`group-collapse-${group.groupId}`" class="constructor__groups__collapse">
                      <draggable
                        :class="`${group.code}`"
                        :list="group.categories"
                        group="categories"
                        :move="checkCategoryMove"
                        :force-fallback="true"
                        ghost-class="sortable__ghost"
                        @change="moveCategoryRequest($event, group)"
                      >
                        <div v-for="(category, i) in group.categories" :key="`${index}-${i}`">
                          <div
                            :id="`group-category-collapse-button-${group.groupId}-${category.categoryId}`"
                            v-b-toggle="`group-category-collapse-${group.groupId}-${category.categoryId}`"
                            :class="{
                              constructor__element__last:
                                i + 1 === group.categories.length && index + 1 === localItems.length,
                              constructor__element__first: i === 0,
                            }"
                            class="constructor__element constructor__element__bg_grey"
                          >
                            <div class="constructor__element__ellipsis">
                              <svg
                                width="8"
                                height="5"
                                viewBox="0 0 8 5"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z"
                                  fill="#0066FF"
                                />
                                <path
                                  d="M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z"
                                  fill="#0066FF"
                                />
                              </svg>
                            </div>

                            <div class="constructor__element__name">{{ category.name }}</div>

                            <b-link class="constructor__element-icons" disabled>
                              <c-button
                                v-if="category.id !== 0"
                                v-b-popover.html="{
                                  id: 'positions-button-popover',
                                  container: '#app',
                                  trigger: 'hover',
                                  content: 'Редактировать',
                                  placement: 'top',
                                }"
                                class="constructor__element-icons-edit"
                                size="iconic"
                                icon="edit"
                                @click="editCategory(category, group.code)"
                              />
                              <c-button
                                v-if="category.posts.length > 0 && category.id !== 0"
                                v-b-popover.html="{
                                  id: 'positions-disable-delete-popover',
                                  container: '#app',
                                  trigger: 'click blur',
                                  content: getCategoryTemplatePopover,
                                }"
                                v-b-tooltip.html="{
                                  id: 'positions-button-tooltip',
                                  container: '#app',
                                  trigger: 'hover',
                                  content: 'Удалить',
                                  title: 'Удалить',
                                  placement: 'top',
                                }"
                                class="constructor__element-icons-delete"
                                :class="{
                                  'constructor__element-icons-delete-disabled':
                                    category.posts !== undefined && category.posts.length > 0,
                                }"
                                size="iconic"
                                :icon="{ icon: 'trash', color: 'secondary' }"
                              />
                              <c-button
                                v-if="category.posts.length === 0 && category.id !== 0"
                                v-b-popover.html="{
                                  id: 'positions-button-popover',
                                  container: '#app',
                                  trigger: 'hover',
                                  content: 'Удалить',
                                  placement: 'top',
                                }"
                                class="constructor__element-icons-delete"
                                size="iconic"
                                :icon="{ icon: 'trash', color: 'secondary' }"
                                @click="openModalRemove(group, 'category', category)"
                              />
                              <c-button
                                v-if="group.categories.length > 1"
                                v-b-popover.html="{
                                  id: 'positions-button-popover',
                                  container: '#app',
                                  trigger: 'hover',
                                  content: 'Переместить',
                                  placement: 'top',
                                }"
                                size="iconic"
                                icon="arrows-constructor"
                              />
                            </b-link>
                          </div>

                          <b-collapse
                            :id="`group-category-collapse-${group.groupId}-${category.categoryId}`"
                            :class="{ constructor__posts__collapse__show: category.posts.length === 0 }"
                            class="constructor__posts__collapse"
                          >
                            <draggable
                              :class="`group-list-${group.code}`"
                              :list="category.posts"
                              group="posts"
                              :move="checkPostMove"
                              :force-fallback="true"
                              ghost-class="sortable__ghost"
                              @change="movePostRequest($event, group, category)"
                            >
                              <div v-for="(post, iPost) in category.posts" :key="`${index}-${i}-${iPost}`">
                                <div
                                  :class="{
                                    constructor__element__last__post:
                                      category.posts.length === iPost + 1 && localItems.length !== index + 1,
                                  }"
                                  class="constructor__element constructor__element__category__children"
                                >
                                  <div class="constructor__element__name constructor__element__name__post">
                                    {{ post.name }}
                                  </div>

                                  <b-link class="constructor__element-icons" disabled>
                                    <c-button
                                      v-b-popover.html="{
                                        id: 'positions-button-popover',
                                        container: '#app',
                                        trigger: 'hover',
                                        content: 'Редактировать',
                                        placement: 'top',
                                      }"
                                      class="constructor__element-icons-edit"
                                      size="iconic"
                                      icon="edit"
                                      @click="goToUpdatePostTest(post.code)"
                                    />
                                    <c-button
                                      v-if="post.code !== 'driver' && Number(post.countWorkers) > 0"
                                      v-b-popover.html="{
                                        id: 'positions-disable-delete-popover',
                                        container: '#app',
                                        trigger: 'click blur',
                                        content: getPostTemplatePopover(post.code),
                                      }"
                                      v-b-tooltip.html="{
                                        id: 'positions-button-tooltip',
                                        container: '#app',
                                        trigger: 'hover',
                                        content: 'Удалить',
                                        title: 'Удалить',
                                        placement: 'top',
                                      }"
                                      class="constructor__element-icons-delete"
                                      :class="{
                                        'constructor__element-icons-delete-disabled':
                                          category.posts !== undefined && category.posts.length > 1,
                                      }"
                                      size="iconic"
                                      :icon="{ icon: 'trash', color: 'secondary' }"
                                    />
                                    <c-button
                                      v-if="post.code !== 'driver' && Number(post.countWorkers) === 0"
                                      v-b-popover.html="{
                                        id: 'positions-button-popover',
                                        container: '#app',
                                        trigger: 'hover',
                                        content: 'Удалить',
                                        placement: 'top',
                                      }"
                                      class="constructor__element-icons-delete"
                                      size="iconic"
                                      :icon="{ icon: 'trash', color: 'secondary' }"
                                      @click="openModalRemove(group, 'post', post)"
                                    />
                                    <c-button
                                      v-b-popover.html="{
                                        id: 'positions-button-popover',
                                        container: '#app',
                                        trigger: 'hover',
                                        content: 'Переместить',
                                        placement: 'top',
                                      }"
                                      size="iconic"
                                      icon="arrows-constructor"
                                    />
                                  </b-link>
                                </div>
                              </div>
                            </draggable>
                          </b-collapse>
                        </div>
                      </draggable>
                    </b-collapse>
                  </div>
                </draggable>

                <div v-if="localItems.length === 0" class="constructor__section-content-empty">
                  Совпадений не найдено
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import { mapGetters } from "vuex";
import Sidesheet from "@/components/sidesheet";

import InputOld from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import ButtonDropdown from "@/components/controls/button-dropdown";
import ItemsModal from "./items-modal";

export default {
  name: "m-filter-constructor",

  components: {
    "c-sidesheet": Sidesheet,
    "c-input-old": InputOld,
    "c-button": Button,
    "c-button-dropdown": ButtonDropdown,
    "m-items": ItemsModal,
    draggable,
  },

  props: ["active", "modalGroups"],

  data() {
    return {
      localActive: this.active,
      searchInput: "",
      localItems: [],
      currentLocalItems: [],
      allGroups: [],
      isShowModalCreateGroup: false,
      isShowModalCreateCategory: false,
      createGroupModalTitle: "",
      createCategoryModalTitle: "",

      groupsForCreateCategoryModal: [],
      requiredMessage: "",
      currentGroup: null,
      currentCategory: null,

      isShowModalRemove: false,
      removeModalTitle: "",
      removeModalDescription: "",
      removeModalDescriptionItem: "",
      removeModalItem: null,
      removeModalItemType: "",

      currentSelectChosenGroupCode: "",
    };
  },

  computed: {
    ...mapGetters("positions", [
      "createGroup",
      "createCategory",
      "removeGroup",
      "removeCategory",
      "removePost",
      "moveCategoryToOtherGroup",
      "moveCategoryInCurrentGroup",
      "movePostInCurrentCategory",
      "movePostInOtherCategory",
      "moveGroup",
      "renameCategory",
    ]),
  },

  watch: {
    active(value) {
      this.localActive = value;
    },

    modalGroups(value) {
      this.localItems = [...value];
      this.localItems.forEach((group, index) => {
        group.groupId = index;
        group.categories.forEach((category, ind) => {
          category.categoryId = ind;
          category.posts.forEach((post, i) => {
            post.postId = i;
          });
        });
      });

      this.allGroups = value;
      this.groupsForCreateCategoryModal = value;
    },

    searchInput(value) {
      const groups = JSON.parse(JSON.stringify(this.allGroups.map((group) => group)));
      const vm = this;

      if (value !== "") {
        const results = groups.filter((group) => {
          let isFoundGroup = false;
          let isFoundCategory = false;
          let isFoundPost = false;
          let idCategoryWhereFindPost;

          if (!group.name.toLowerCase().includes(value.toLowerCase())) {
            group.categories = group.categories.filter((category) => {
              if (category.name.toLowerCase().includes(value.toLowerCase())) {
                setTimeout(() => {
                  if (document.getElementById(`group-collapse-${group.groupId}`) !== null) {
                    const isShowCategory = document
                      .getElementById(`group-collapse-button-${group.groupId}`)
                      .getAttribute("aria-expanded");
                    if (isShowCategory === "false") {
                      vm.$root.$emit("bv::toggle::collapse", `group-collapse-${group.groupId}`);
                    }
                  }
                }, 200);
                isFoundCategory = true;
                return true;
              }
              category.posts = category.posts.filter((post) => {
                if (post.name.toLowerCase().includes(value.toLowerCase())) {
                  if (document.getElementById(`group-collapse-${group.groupId}`) !== null) {
                    const isShowCategory = document
                      .getElementById(`group-collapse-button-${group.groupId}`)
                      .getAttribute("aria-expanded");
                    if (isShowCategory === "false") {
                      vm.$root.$emit("bv::toggle::collapse", `group-collapse-${group.groupId}`);
                    }
                  }
                  setTimeout(() => {
                    if (
                      document.getElementById(`group-category-collapse-${group.groupId}-${category.categoryId}`) !==
                      null
                    ) {
                      const isShowPosts = document
                        .getElementById(`group-category-collapse-button-${group.groupId}-${category.categoryId}`)
                        .getAttribute("aria-expanded");
                      if (isShowPosts === "false") {
                        vm.$root.$emit(
                          "bv::toggle::collapse",
                          `group-category-collapse-${group.groupId}-${category.categoryId}`,
                        );
                      }
                    }
                  }, 200);
                  idCategoryWhereFindPost = category.id;
                  isFoundPost = true;
                  return true;
                }
                return false;
              });

              return isFoundPost;
            });
          }

          if (group.name.toLowerCase().includes(value.toLowerCase())) {
            isFoundGroup = true;
          }

          if (isFoundPost) {
            group.categories = group.categories.filter((cat) => cat.id === idCategoryWhereFindPost);
          }

          return isFoundCategory || isFoundPost || isFoundGroup;
        });

        this.localItems = [...results];
      } else {
        this.localItems = [...groups];
      }
    },

    localItems: {
      handler(newVal) {
        this.currentLocalItems = [...newVal];
        this.$forceUpdate();
      },
      deep: true,
    },
  },

  created() {
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      this.$root.$emit("bv::hide::popover");
    });
    const that = this;

    document.addEventListener("keyup", (evt) => {
      if (evt.keyCode === 27) {
        if (that.active && !that.isShowModalCreateGroup && !that.isShowModalCreateCategory && !that.isShowModalRemove) {
          that.close();
        }
      }
    });
  },

  methods: {
    hasCategoryWithPosts(group) {
      return (
        group.removable === 1 &&
        (group.categories.length > 1 || (group.categories[0] && group.categories[0].posts.length > 0))
      );
    },
    shouldDisplayDeleteButton(group) {
      return (
        group.removable === 1 &&
        group.categories.length <= 1 &&
        group.categories[0] &&
        !group.categories[0].posts.length
      );
    },
    openModalCreateGroup() {
      this.createGroupModalTitle = "Новая группа";
      this.isShowModalCreateGroup = true;
    },

    openModalCreateCategory() {
      this.createCategoryModalTitle = "Новая категория";
      this.isShowModalCreateCategory = true;
    },

    openModalRemove(group, typeItem, item) {
      switch (typeItem) {
        case "group":
          this.removeModalTitle = "Удаление группы";
          this.removeModalDescription = "Подтвердите удаление группы";
          this.removeModalDescriptionItem = group.name;
          this.removeModalItem = group;
          this.removeModalItemType = typeItem;
          break;
        case "category":
          this.removeModalTitle = "Удаление категории";
          this.removeModalDescription = "Подтвердите удаление категории";
          this.removeModalDescriptionItem = item.name;
          this.removeModalItem = item;
          this.removeModalItemType = typeItem;
          break;
        case "post":
          this.removeModalTitle = "Удаление должности";
          this.removeModalDescription = "Подтвердите удаление должности";
          this.removeModalDescriptionItem = item.name;
          this.removeModalItem = item;
          this.removeModalItemType = typeItem;
          break;
        default:
          this.removeModalTitle = "";
      }

      this.isShowModalRemove = true;
    },

    closeModalCreateGroup() {
      setTimeout(() => {
        this.createGroupModalTitle = "";
        this.requiredMessage = "";
        this.currentGroup = null;
      }, 300);
      setTimeout(() => {
        this.isShowModalCreateGroup = false;
      }, 150);
    },

    closeModalCreateCategory() {
      setTimeout(() => {
        this.createCategoryModalTitle = "";
        this.requiredMessage = "";
        this.currentCategory = null;
      }, 300);
      setTimeout(() => {
        this.isShowModalCreateCategory = false;
      }, 150);
    },

    closeModalRemove() {
      setTimeout(() => {
        this.removeModalTitle = "";
        this.removeModalDescription = "";
        this.removeModalDescriptionItem = "";
        this.removeModalItem = null;
      }, 300);
      setTimeout(() => {
        this.isShowModalRemove = false;
      }, 150);
    },

    createGroupRequest(groupName) {
      if (groupName.length === 0 || groupName.trim().length === 0) {
        this.requiredMessage = "Обязательное поле";
      } else if (groupName.length > 64) {
        this.requiredMessage = "Название группы не может содержать более 64 символов";
      } else {
        this.$store.dispatch("positions/createGroup", groupName).then((res) => {
          if (res.errors !== undefined && res.errors.name) {
            this.requiredMessage = "Группа с указанным названием уже добавлена";
          } else {
            this.$emit("updatePostGroups");
            this.closeModalCreateGroup();
          }
        });
      }
    },

    renameGroup(group) {
      this.currentGroup = { ...group };
      this.openModalCreateGroup();
      this.createGroupModalTitle = "Редактирование группы";
    },

    renameGroupRequest(groupCode, groupName) {
      if (groupName.length === 0 || groupName.trim().length === 0) {
        this.requiredMessage = "Обязательное поле";
      } else if (groupName.length > 64) {
        this.requiredMessage = "Название группы не может содержать более 64 символов";
      } else {
        this.$store.dispatch("positions/renameGroup", [groupCode, groupName]).then((res) => {
          if (res.errors !== undefined && res.errors.name) {
            this.requiredMessage = "Группа с указанным названием уже добавлена";
          } else {
            this.$emit("updatePostGroups");
            this.closeModalCreateGroup();
          }
        });
      }
    },

    editCategory(category, groupCode) {
      this.currentSelectChosenGroupCode = groupCode;
      this.currentCategory = { ...category };
      this.openModalCreateCategory();
      this.createCategoryModalTitle = "Редактирование категории";
    },

    editCategoryRequest(categoryId, categoryName, currentGroup) {
      if (categoryName === "Без категории") {
        this.requiredMessage = "Категория с указанным названием уже добавлена";
        return;
      }

      if (categoryName.length === 0 || categoryName.trim().length === 0) {
        this.requiredMessage = "Обязательное поле";
      } else if (categoryName.length > 255) {
        this.requiredMessage = "Название категории не может содержать более 255 символов";
      } else {
        this.$store.dispatch("positions/editCategory", [categoryId, categoryName, currentGroup.value]).then((res) => {
          if (res.errors !== undefined && res.errors.name) {
            this.requiredMessage = "Категория с указанным названием уже добавлена";
          } else {
            this.$emit("updatePostGroups");
            this.closeModalCreateCategory();
          }
        });
      }
    },

    createCategoryRequest(codeGroup, nameCategory) {
      if (nameCategory === "Без категории") {
        this.requiredMessage = "Категория с указанным названием уже добавлена";
        return;
      }

      if (nameCategory.length === 0 || nameCategory.trim().length === 0) {
        this.requiredMessage = "Обязательное поле";
      } else if (nameCategory.length > 255) {
        this.requiredMessage = "Название категории не может содержать более 255 символов";
      } else {
        this.$store.dispatch("positions/createCategory", [codeGroup, nameCategory]).then((res) => {
          if (res.errors !== undefined && res.errors.name) {
            this.requiredMessage = "Категория с указанным названием уже добавлена";
          } else {
            this.$emit("updatePostGroups");
            this.closeModalCreateCategory();
          }
        });
      }
    },

    removeItemRequest(itemType, item) {
      switch (itemType) {
        case "group":
          this.$store.dispatch("positions/removeGroup", item.code).then((res) => {
            if (res.errors === undefined) {
              // Обновляем список групп и сообщаем код удалённой группы
              this.$emit("updatePostGroups", item.code);
            }
            this.closeModalRemove();
          });
          break;
        case "category":
          this.$store.dispatch("positions/removeCategory", item.id).then((res) => {
            if (res.errors === undefined) {
              this.$emit("updatePostGroups");
            }
            this.closeModalRemove();
          });
          break;
        case "post":
          this.$store.dispatch("positions/removePost", item.code).then((res) => {
            if (res.errors === undefined) {
              this.$emit("updatePostGroups");
            }
            this.closeModalRemove();
          });
          break;
        default:
          this.closeModalRemove();
          break;
      }
    },

    checkCategoryMove(e) {
      const classGroupTo = e.to.classList[0];
      // const classGroupFrom = e.to.classList[0];

      const categoryName = e.draggedContext.element.name;
      const codeGroupTo = e.to.classList[0];
      const c = this.localItems.findIndex((group) => group.code === codeGroupTo);

      if (c !== -1) {
        const { categories } = this.localItems[c];

        const b = categories.findIndex((category) => category.name === categoryName);
        if (b !== -1) {
          return false;
        }
      }

      if (e.draggedContext.element.id === 0 && e.from !== e.to) {
        return false;
      }

      if (classGroupTo === "group-list-driver") {
        return false;
      }

      return true;
    },

    checkPostMove(e) {
      const classGroupTo = e.to.classList[0];

      if (e.draggedContext.element.code === "driver") {
        return false;
      }

      return classGroupTo !== "group-list-driver";
    },

    moveCategoryRequest(e, group) {
      if (e.added !== undefined) {
        this.$store.dispatch("positions/moveCategoryToOtherGroup", [group.code, e.added.element.id]).then((res) => {
          if (res.errors === undefined) {
            this.$emit("updatePostGroups");
            this.searchInput = "";
          }
        });
      }
      if (e.moved !== undefined) {
        this.$store.dispatch("positions/moveCategoryInCurrentGroup", [group.code, group.categories]).then((res) => {
          if (res.errors === undefined) {
            this.$emit("updatePostGroups");
            this.searchInput = "";
          }
        });
      }
    },

    movePostRequest(e, group, category) {
      if (e.added !== undefined) {
        this.$store
          .dispatch("positions/movePostToOtherCategory", [group.code, category.id, e.added.element.code])
          .then((res) => {
            if (res.errors === undefined) {
              this.$emit("updatePostGroups");
              this.searchInput = "";
            }
          });
      }
      if (e.moved !== undefined) {
        this.$store.dispatch("positions/movePostInCurrentCategory", [group.code, category]).then((res) => {
          if (res.errors === undefined) {
            this.$emit("updatePostGroups");
            this.searchInput = "";
          }
        });
      }
    },

    moveGroupRequest(e, groups) {
      if (e.moved !== undefined) {
        this.$store.dispatch("positions/moveGroup", groups).then((res) => {
          if (res.errors === undefined) {
            this.$emit("updatePostGroups");
            this.searchInput = "";
          }
        });
      }
    },

    close() {
      this.searchInput = "";
      this.$emit("close");
    },

    save() {
      // this.$emit('save', enabledFields);

      this.$emit("close");
    },

    reset() {
      this.disabled = this.allFilters;
      this.enabled.length = 0;

      this.$emit("submit", []);

      this.$emit("close");
    },

    log(evt) {
      window.console.log(evt);
    },

    goToUpdatePost(code) {
      if (code === "driver") {
        window.open(`index.php?r=redesign#/position-form/${code}`, "_blank");
      } else {
        window.open(`index.php?r=redesign#/position-form/${code}`, "_blank");
      }
    },

    goToUpdatePostTest(code) {
      this.$router.push({ name: "position-form", params: { positionCode: code } });
    },

    showDisableDeleteCategoryPopover(i, index) {
      this.$root.$emit("bv::show::popover", `positions-delete-category-disable-${i}-${index}`);
    },

    changeRequiredMessage(value) {
      this.requiredMessage = value;
    },

    getGroupTemplatePopover() {
      return `<svg class="b-popover-warning" width="14" height="14" viewBox="0 0 14 14" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"/>
                <circle cx="7" cy="10" r="1" fill="#FF238D"/>
                <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"/>
              </svg>
              <div class="b-popover-text">Нельзя удалить группу, пока в ней есть хотя бы одна категория или должность</div>
              <svg className="b-popover-close" width="15" height="15" viewBox="0 0 15 15" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z"
                  fill="#8E9CBB"/>
                <path
                d="M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z"
                  fill="#8E9CBB"/>
              </svg>`;
    },

    getCategoryTemplatePopover() {
      return `<svg class="b-popover-warning" width="14" height="14" viewBox="0 0 14 14" fill="none"
               xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"/>
                <circle cx="7" cy="10" r="1" fill="#FF238D"/>
                <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"/>
              </svg>
              <div class="b-popover-text">Нельзя удалить категорию, пока в ней есть хотя бы одна должность</div>
              <svg class="b-popover-close" width="15" height="15" viewBox="0 0 15 15" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z"
                  fill="#8E9CBB"/>
                <path
                  d="M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z"
                  fill="#8E9CBB"/>
              </svg>`;
    },

    getPostTemplatePopover(postCode) {
      return `<svg class="b-popover-warning" width="14" height="14" viewBox="0 0 14 14" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"/>
                <circle cx="7" cy="10" r="1" fill="#FF238D"/>
                <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"/>
              </svg>
              <div class="b-popover-text b-popover-text-mr-28">
                <p>Нельзя удалить должность, пока хотя бы один сотрудник относится к ней.</p>
                <a onclick="window.open(this.href,'_blank');return false;" class="b-popover-text-link" href="/?r=redesign#/employees/employees-list?sortBy=created&sortType=desc&postCategorySpecialty=${postCode}&postCategorySpecialty_filterType=list&postCategorySpecialty_searchType=1">Перейти к списку сотрудников</a>
              </div>
              <svg class="b-popover-close" width="15" height="15" viewBox="0 0 15 15" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z"
                  fill="#8E9CBB"/>
                <path
                  d="M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z"
                  fill="#8E9CBB"/>
              </svg>`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.constructor {
  &__header {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    &__close {
      position: absolute;
      top: 12px;
      right: 12px;
      display: none;

      @media screen and (max-width: 700px) {
        display: block;
      }
    }

    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 108%;
      color: #000000;

      @media screen and (max-width: 700px) {
        font-size: 18px;
      }
    }

    &__button {
      margin-right: 14px;

      @media screen and (max-width: 700px) {
        margin-top: 20px;
      }
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__description {
    font: {
      size: 11px;
    }
    line-height: 12px;
    color: $color-label;
    margin-top: 16px;
    margin-bottom: 24px;
    flex-basis: 24px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  }

  &__search {
    margin-top: 35px;
    width: 365px;

    @media screen and (max-width: 1024px) {
      padding-right: 14px;
      width: 100%;
    }

    @media screen and (max-width: 700px) {
      padding-right: 0;
      margin-top: 21px;
    }
  }

  &__sections {
    margin-top: 28px;
    display: flex;
    flex-grow: 1;
    height: calc(100% - 120px);
  }

  &__section {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    width: calc(50% - 24px);

    &-title {
      font: {
        size: 15px;
        weight: 500;
      }
      line-height: 18px;
    }

    &-content {
      overflow-y: auto;
      flex-grow: 1;
      padding-right: 14px;
      position: relative;
      overflow-x: hidden;
      z-index: 1;
      height: calc(100% - 36px);
      max-height: calc(100% - 20px);

      @media screen and (max-width: 700px) {
        padding-right: 0;
        margin-left: -20px;
      }

      &-empty {
        font-size: 15px;
        @media screen and (max-width: 700px) {
          margin-left: 20px;
        }
      }

      @media screen and (max-width: 700px) {
        padding: 0;
        width: calc(100% + 40px);
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 100%;
      }

      &::-webkit-scrollbar-thumb {
        background: $color-secondary;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background: $color-border-alt;
      }
    }
  }

  &__element {
    display: flex;
    padding: 0 22px;
    align-items: center;
    width: calc(100% + 3px);
    height: 48px;
    position: relative;
    z-index: 2;
    border: 1px solid #dfe4ef;
    cursor: move;
    transition: 0.2s;
    border-bottom-width: 0;

    &[aria-expanded="false"] + .collapse {
      display: block !important;

      & div div {
        display: none !important;
      }

      & div div.sortable__ghost {
        display: block !important;
      }
    }

    &__first {
      border-top-width: 0;
    }

    &__last {
      border-bottom-width: 1px;

      &__post {
        border-bottom-width: 0 !important;
      }
    }

    &[aria-expanded="true"] {
      border-bottom-width: 1px;
    }

    &:last-child {
      border-bottom-width: 1px;
    }

    &__name {
      max-width: 100%;
      width: 100%;
      overflow: hidden;
      font-size: 15px;
      line-height: 108%;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 14px;

      &__post {
        font-size: 13px;
      }
    }

    &:focus {
      outline: none !important;
    }

    &__bold {
      font-weight: 500;
    }

    &__bg_grey {
      background: #f5f7fa;
    }

    &__ellipsis {
      width: 22px;
      min-width: 22px;
      height: 22px;
      margin-right: 14px;
      border-radius: 50%;
      cursor: pointer;
      background: #ffffff;
      border: 1px solid #d3d8df;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__category__children {
      height: 35px;
      font-size: 13px;
      line-height: 108%;
      border-top-width: 0;
    }

    &-icons {
      display: flex;
      align-items: center;
      height: 100%;
      flex-shrink: 0;
      margin-left: auto;

      &-edit,
      &-delete {
        margin-right: 16px;
      }

      &-delete {
        &-disabled {
          fill-opacity: 0.5;
        }
      }
    }

    &-label {
      width: calc(100% - 30px);
      margin-right: 10px;
      font-size: 13px;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: $color-label;
        margin-bottom: 0;

        span {
          color: $color-font;
        }
      }
    }
  }

  &__groups__collapse {
    margin-left: 16px;

    @media screen and (max-width: 700px) {
      margin-left: 0;
    }
  }

  &__posts__collapse {
    margin-left: 37px;

    @media screen and (max-width: 700px) {
      margin-left: 0;
    }

    &__show {
      display: block !important;
    }
  }

  &__actions {
    height: 38px;
    display: flex;
    margin-top: 30px;

    &-item {
      margin-right: 10px;
    }
  }
}

::v-deep .sidesheet__wrapper {
  width: calc(100vw - 161px);
  padding: 38px 14px 38px 31px;

  @media screen and (max-width: 1024px) {
    width: calc(100vw - 62px);
  }

  @media screen and (max-width: 700px) {
    padding: 28px 20px;
    max-width: 100%;
    width: 100%;
  }
}

::v-deep .sortable-drag .c-button_icon_arrows-constructor .c-button-icon svg path {
  fill: #0066ff !important;
}

::v-deep .sidesheet__header {
  flex-basis: 0;
}

::v-deep .sortable__ghost {
  height: 5px;
  width: calc(100% + 3px) !important;
  overflow: hidden;
  background: $color-primary;
  opacity: 1;

  * {
    display: none;
  }
}

.sortable-drag {
  opacity: 1 !important;
}

.sortable-drag .constructor__element {
  opacity: 1 !important;
  background: white;
  border-bottom: none;
  box-shadow: 0px 3px 16px rgba(0, 102, 255, 0.7);
}

::v-deep .sortable-drag .constructor__element + .collapse {
  display: none !important;
}
</style>
